import type { Release } from '../releases.ts';

export default {
  version: '1.2.6',
  date: '2026-10-21',
  title: 'Motion: smoother moves between pages',
  summary: [
    'The landing page’s search box glides into the Library, and back when you go home',
    'The rail’s highlight slides to the page you open; pages crossfade quickly',
    'Library cards fade in on first load and lift on hover; posters fade in once loaded',
    'Everything is instant when the system asks for reduced motion',
  ],
  upgradeSummary: [
    'Nothing to do but upgrade: no migration, no new settings',
    'Storage agents need no update; rolling back to 1.2.5 is possible',
  ],
  upgradeGuide: 'upgrading-to-126',
  beforeUpgrade: [
    'Nothing to do but pull and rebuild: a web-only release, with no migration, no new settings and no API change (docs/deployment.md, “Upgrading to 1.2.6”)',
    'Rolling back to 1.2.5: git checkout v1.2.5 and docker compose up -d --build',
    'Storage agents: no update needed',
  ],
  features: [
    'Landing page to Library: searching from the landing page keeps the search box on screen and glides it into the Library’s toolbar while the slogan fades out; the PRISM logo takes it back. It uses the browser’s View Transitions API (Chrome and Edge, Safari 18 and later); where a browser lacks it, the page changes at once as before',
    'Rail: the active item’s accent pill slides to the page you open, and every page switch from the rail crossfades in about 0.16 seconds',
    'Library cards: every card of the first results fades in and rises, 25 ms apart (the delay capped at 0.6 s), when the Library opens; Load more, refreshes and a new search do not animate again. A card lifts slightly on hover with an accent edge',
    'Posters fade in over their placeholder when they have loaded; a poster already in memory shows at once',
    'Reduced motion: with the system setting to reduce motion, page transitions, the card fade-in and the hover lift are off. The mobile view and shared links are unchanged',
  ],
  fixes: [],
} satisfies Release;
